<template>
  <div class="kds-main-wrapper">
    <div class="kds-content-block">
      <h2
        class="kds-typography-display-small"
        v-html="$t('b2b_acknowledgements_page_title')"
      />
      <p
        class="kds-typography-paragraph-large"
        v-html="$t('b2b_acknowledgements_page_intro')"
      />
    </div>

    <ul class="kds-content-block">
      <li
        v-for="(license, name, index) in licenses"
        :key="index"
      >
        <h3
          v-if="license.repository"
          class="kds-typography-title-medium"
        >
          <a
            :href="license.repository"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ name }}
          </a>
        </h3>
        <h3
          v-else
          class="kds-typography-title-medium"
        >
          {{ name }}
        </h3>

        <p v-if="license.publisher">({{ license.publisher }})</p>

        <p>{{ license.licenses }}</p>
      </li>
    </ul>
  </div>
</template>

<script setup>
import licenses from '@shared/public/static/license-list.json'
</script>
